import { Create, SimpleForm } from "react-admin";

import useCreateWithValidation from "../common/useCreateWithValidation";
import {
  sanitizeServiceResources,
} from "./ServiceResourcesInput";
import ServiceTemplateFields from "./fields";

const ServiceTemplateCreate = () => {
  const save = useCreateWithValidation("ServiceTemplate", {
    redirectTo: "list",
    transform: sanitizeServiceResources,
  });

  return (
    <Create>
      <SimpleForm
        defaultValues={{
          resources: {},
        }}
        onSubmit={save}
      >
        <ServiceTemplateFields />
      </SimpleForm>
    </Create>
  );
};
export default ServiceTemplateCreate;
